import { Link } from "@tanstack/react-router";

import LogoWL from "~/assets/logo_wl.svg";

import { WelcomeProgress } from "../welcome/components/welcome-progress";
import ConsultationBooking from "~/features/appointments/pages/consultation-booking";
// import { AppointmentBooking } from "~/features/consultations/pages/booking";

// const LAST_STEP = 2;

export default function ConsultationPage() {
//   const { date: dateParam, slot: slotParam, step = "1" } = useSearch({ from: "/(public)/_public/consultations/" });

//   const successUrl = `${window.location.origin}/consultations/confirmation`;
//   const errorUrl = `${window.location.origin}/consultations/error`;

//   const pageStep = Number(step);
//   const currentStep = isNaN(pageStep) ? 1 : Math.max(Math.min(LAST_STEP, pageStep), 1)


  return (
    <div className="relative h-full w-full">
      <WelcomeProgress currentStep={11} totalSteps={13} />
      <div className="relative flex flex-col justify-between px-4">
        <Link to="/" className="mx-auto my-[24px] md:my-[40px] lg:my-[50px] xl:my-[60px]">
          <img
            src={LogoWL}
            alt="Proxymed logo"
            className="max-w-[160px] md:max-w-[180px] lg:max-w-[200px] xl:max-w-none"
          />
        </Link>
        {/* <AppointmentBooking step={currentStep} appointmentTitle="First weight loss consultation" selectedSlot={slotParam} selectedDate={dateParam} to="/consultations" successUrl={successUrl} errorUrl={errorUrl} /> */}
        <ConsultationBooking />
      </div>
    </div>
  );
}
